import { TableCell } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const MyTableCell = withStyles({
	root: {
		borderBottom: 'none',
		border: 'none'
	}
})(TableCell);

export default MyTableCell;
